export const getIssAliquot = (
  isRetained: boolean,
  fetchedAliquot: string,
  userAliquot: string
): string => isRetained ? userAliquot : fetchedAliquot;
